module.exports = __webpack_public_path__ + "r-v3/img/slowly.2066efff.svg";